<template>
    <section class="Menu">
        <header class="px-10 pa-6"> 
            <h2 class="mb-10 mt-4 white--text">{{$t("orders.title")}} ?</h2>
            <div class="overlay black"></div>
            <div class="menuBtn">
                <v-row
                class="fill-height"
                justify="center"
                >
                     <v-slide-group
                    show-arrows
                    dark
                    v-if="categorieLoading"
                    >
                    <v-slide-item
                    v-for="(btn, index) in numCategorie" :key="index"
                    >
                    <v-skeleton-loader
                    class="mx-2 rounded-pill grey lighten-2"
                    type="button"
                    ></v-skeleton-loader>
                    </v-slide-item>
                    </v-slide-group>
                    <v-slide-group
                    v-model="activeMenu"
                    show-arrows
                    dark
                    >
                    <v-slide-item
                    v-for="(categorie, index) in buttonsMenu" :key="index"
                    v-show="!categorieLoading"
                    >
                    <v-btn light v-text="categorie[lang]" class="mx-2 rounded-pill"
                    style="box-shadow:none" :ripple="true"
                    @click="getMenuData(categorie.id)" :class="categorie.id==activeMenu?'active-menu':''"
                    ></v-btn>
                    </v-slide-item>
                    </v-slide-group>
                </v-row>
            </div>
        </header>
         <v-container>
         <v-row>
          <v-col
            :md="6"
            :sm="12"
            :cols="12"
            class="flex-"
            v-for="(num, index) in numItems" :key="index"
            >
            <v-skeleton-loader
             v-if="loading"
              class="mx-auto white"
              max-width="370"
              type="image,article"
            ></v-skeleton-loader>  
          </v-col>  
          </v-row>
         <div class="menu">
                <v-row>
                <v-col
                :md="6"
                :sm="12"
                :cols="12"
                class="flex-"
                v-for="(menu, index) in menuListes" :key="index"
                >
                <v-card
                max-width="360"
                class="mx-auto"
                height="350px"
                flat
                :outlined='true'
                :hover="true"
               >
            <div class="d-flex justify-center pt-3 align-center ">
            <v-badge
            :content="menu.discount+'% off'"
            overlap
            :value="menu.discount!=''"
            bottom
            offset-x="0"
            color="green"
            class="font-weight-bold"
            >
            <v-img  :src="menu.img" alt="menu.title" 
          max-width="108"
          height="108"
          :contain="true"
          >
          <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="black"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            </v-badge>
            </div>
            <v-card-title  class="red--text font-weight-bold" v-text="menu[lang].title"></v-card-title>
            <v-card-subtitle  class="pb-2 font-weight-bold">
            price :<span :class="menu.discount!='' ? 'text-decoration-line-through' :''"> {{menu.price}}$</span>
            <span class="ml-6 mr-6  grey white--text pa-1 pr-3 pl-3 rounded" v-if="menu.discount!=''">{{priceAfterDiscount(menu)}}$</span>
            </v-card-subtitle>
            <v-card-text class="text--primary">
                <div v-text="menu[lang].description"></div>
            </v-card-text>
            <v-card-actions>
             <v-btn
              block
              color="red"
              class="white--text"
              depressed
              :ripple="true"
              :disabled='alreadyOrderd(menu.id)'
              @click="commander(menu[lang].title,menu.id,menu.discount!='' ? priceAfterDiscount(menu):menu.price,menu.img)"
             >
             <v-icon :style="plusIconStyle">fa fa-cart-plus</v-icon>
             {{$t('orders.facteur.addShopinCard')}}
             </v-btn>
            </v-card-actions>
            </v-card>
                </v-col>
                </v-row>
        </div>
         </v-container>
         <AppFooter />
    </section>
</template>

<script>
import AppFooter from '@/components/footer/Footer.vue';
import {menuMixing,lang} from '@/mixins/index'

export default {
    name:'order-header',
    data() {
        return {
            comannd:[],
            plusIconStyle:{
                fontSize: '11pt',
                padding: '0 12px'
            }
        }
    },
    mixins:[menuMixing,lang],
    components:{AppFooter},
    methods:{
        changeTheMenu(value){
         this.activeMenu=value;
        },
        priceAfterDiscount(menu){
           return parseInt(menu.price) - (parseInt(menu.price)*parseInt(menu.discount))/100;
        },
        commander(name,id,price,image){
          this.$store.state.orders.unshift({
              name:name,
              id:id,
              img:image,
              price:price,
              quntite:1
          })
        },
        alreadyOrderd(orderdId){
            let isOrderd=false;
            this.$store.state.orders.forEach(order=>{
                if(order.id==orderdId){
                    isOrderd=true;
                }
            })
            return isOrderd;
        }
    }
}
</script>

<style lang="scss" scoped>
     header{
      background-image: url('./../../assets/backgrounds/order/order-3.jpg');
      background-size: cover;
      background-position:100%;
      position: relative;
      h2{
          position: relative;
          z-index: 2;
      }
      .overlay{
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          opacity: .4;
          z-index: 0;
      }
    }
     .active-menu{
    background-color: #000 !important;
    color: #fff !important;
  }
</style>